<div class="container">
   <div class="row">
      <div class="col">
         <div class="service d-flex flex-column align-items-center mb-5 justify-content-center">
            <div class="service-title d-flex justify-content-center mb-5 mr-5 mt-5">
               <button
                  class="service-title__btn btn btn-outline-info text-dark mb-1 ml-5"
                  routerLink="/public/landing-page"
               >
                  <i class="bi bi-arrow-left-short"> </i>{{ 'buttons.back' | translate }}
               </button>
               <div class="service-title__tll">
                  <h5 class="service-title__tll--tile">{{ translatePath + 'title' | translate }}</h5>
               </div>
            </div>
            <div class="service-box d-flex justify-content-center align-items-center mb-5 mt-3">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex justify-content-center align-items-center">
                     <span class="text-white">1</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ translatePath + 'title1' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/about-delivery/Group 1623.svg"
                     alt="service"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex">
                  <p class="service-box__about--text">
                     {{ translatePath + 'data1' | translate }}
                  </p>
               </div>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center mb-5">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">2</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ translatePath + 'title2' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/about-delivery/Group 1625.svg"
                     alt="international"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex">
                  <p class="service-box__about--text">
                     {{ translatePath + 'data2' | translate }}
                  </p>
               </div>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center" [ngClass]="{mb: !lookAbout}">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">3</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ translatePath + 'title3' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/about-delivery/Group 1626.svg"
                     alt="toDoor"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex flex-column">
                  <ul class="service-box__about--text">
                     <li>
                        {{ translatePath + 'data3-1' | translate }}
                     </li>
                     <li>
                        {{ translatePath + 'data3-2' | translate }}
                     </li>
                  </ul>

                  <a class="service-box__about--link d-flex ml-auto" (click)="seeAbout()"
                     ><span class="text-center"></span> {{ translatePath + 'read' | translate }}
                     <span [ngClass]="{active: lookAbout}">
                        <img class="ml-1 mr-1" width="11" src="./../../../assets/images/arrowUp.svg" /></span
                  ></a>
               </div>
            </div>

            <div *ngIf="lookAbout" class="service-read mb-3 mt-3">
               <ul class="service-read__text">
                  <li>
                     {{ translatePath + 'data3-3' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-4' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-5' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-6' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-7' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-8' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-9' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-10' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-11' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-12' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-13' | translate }}
                  </li>
                  <li>
                     {{ translatePath + 'data3-14' | translate }}
                  </li>
               </ul>
            </div>

            <div class="service-box d-flex justify-content-center align-items-center mb-5 mt-2">
               <div class="service-box__nbr mr-5">
                  <div class="service-box__nbr--item d-flex">
                     <span class="text-white">4</span>
                  </div>
               </div>

               <div class="service-box__item mr-5 d-flex flex-column justify-content-center align-items-center">
                  <p class="service-box__item--text">{{ translatePath + 'title4' | translate }}</p>
                  <img
                     class="service-box__item--img"
                     src="./../../../assets/images/about-delivery/Group 1624.svg"
                     alt="howthisWork"
                  />
               </div>

               <div class="service-box__about mr-5 d-flex align-items-center">
                  <p class="service-box__about--text">
                     {{ translatePath + 'data4' | translate }}
                     <a href="mailto:suport.mdelivery@egov.md">suport.mdelivery@egov.md</a>.
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
